export type StreakDayStatus = 'done' | 'repaired' | 'missed' | 'today' | 'future' | 'before'

export type StreakHint =
  | { kind: 'guest' }
  | { kind: 'start' }
  | { kind: 'progress'; left: number }
  | { kind: 'repairable'; weekday: number; count: number; cost: number }
  | { kind: 'missed' }
  | { kind: 'done' }
  | { kind: 'past-done' }
  | { kind: 'past-missed' }

export const WEEKDAY_SHORT = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'] as const

const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
] as const

export function plural(n: number, forms: readonly [string, string, string]): string {
  const m10 = n % 10
  const m100 = n % 100
  if (m10 === 1 && m100 !== 11) return forms[0]
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return forms[1]
  return forms[2]
}

export function lunars(n: number): string {
  return `${n} ${plural(Math.abs(n), ['лунар', 'лунара', 'лунаров'])}`
}

export function daysWord(n: number): string {
  return plural(n, ['день', 'дня', 'дней'])
}

export function dayMonth(date: string): string {
  const [, month, day] = date.split('-').map(Number)
  return `${day ?? ''} ${MONTHS_GENITIVE[(month ?? 1) - 1] ?? ''}`
}

export function weekRange(start: string, end: string): string {
  const [, m1, d1] = start.split('-').map(Number)
  const [, m2, d2] = end.split('-').map(Number)
  return m1 === m2 ? `${d1 ?? ''}–${dayMonth(end)}` : `${dayMonth(start)} – ${d2 ?? ''} ${MONTHS_GENITIVE[(m2 ?? 1) - 1] ?? ''}`
}

type HintInput = {
  statuses: ReadonlyArray<StreakDayStatus>
  current: boolean
  guest: boolean
  rewarded: boolean
  balance: number
  price: number
}

export function streakHint({ statuses, current, guest, rewarded, balance, price }: HintInput): StreakHint {
  if (guest) return { kind: 'guest' }
  const counted = statuses.filter((s) => s === 'done' || s === 'repaired').length
  if (!current) return rewarded || counted === 7 ? { kind: 'past-done' } : { kind: 'past-missed' }
  if (rewarded || counted === 7) return { kind: 'done' }
  if (statuses.includes('before')) return { kind: 'missed' }
  const first = statuses.indexOf('missed')
  if (first >= 0) {
    const count = statuses.filter((s) => s === 'missed').length
    const cost = count * price
    return balance >= cost ? { kind: 'repairable', weekday: first + 1, count, cost } : { kind: 'missed' }
  }
  if (counted === 0) return { kind: 'start' }
  return { kind: 'progress', left: 7 - counted }
}

export function shiftDays(date: string, days: number): string {
  const d = new Date(`${date}T00:00:00.000Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}
